module.exports = __webpack_public_path__ + "static/media/deutscher.6975a65a.png";